import { ReactElement } from 'react';

import { PatientReferenceIdentifier } from '@dreryk/egabinet-patient-published-language-api';

import { IconFillColor, IconSize, IconWrapper, UnknownPersonIcon } from '@dreryk/react-components';

type AppointmentsTimetableEventUnknownPatientIconProps = {
   patientReferenceIndentifier: PatientReferenceIdentifier | undefined;
};

export const AppointmentsTimetableEventUnknownPatientIcon = (
   props: AppointmentsTimetableEventUnknownPatientIconProps
): ReactElement | null => {
   if (props.patientReferenceIndentifier) {
      return null;
   }

   return (
      <IconWrapper testId={'unknownPatient'} fillColor={IconFillColor.ERROR} size={IconSize.SMALLEST}>
         <UnknownPersonIcon />
      </IconWrapper>
   );
};
